import React, { useEffect, useState } from "react";

import API from "../../../services/api";

import {

    Store,

    Wallet,

    CalendarDays,

    CheckCircle2

} from "lucide-react";

import "./TransactionCard.css";

function TransactionCard() {

    const [transactions, setTransactions] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        fetchTransactions();

    }, []);

    const fetchTransactions = async () => {

        try {

            const response = await API.get(

                "/delivery/earnings/history"

            );

            if (response.data.success) {

                setTransactions(
    response.data.history || []
);

            }

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    };

    const formatDate = (date) => {

        return new Date(date).toLocaleString(

            "en-IN",

            {

                day: "numeric",

                month: "short",

                year: "numeric",

                hour: "numeric",

                minute: "2-digit",

            }

        );

    };

    return (

        <div className="transaction-section">

            <div className="section-title">

                <h2>

                    Transaction History

                </h2>

            </div>

            {

                loading ?

                (

                    <div
                        style={{
                            textAlign:"center",
                            padding:"30px"
                        }}
                    >

                        Loading...

                    </div>

                )

                :

                transactions.length===0 ?

                (

                    <div
                        style={{
                            textAlign:"center",
                            padding:"30px"
                        }}
                    >

                        No Transactions Found

                    </div>

                )

                :

                (

                    transactions.map((item)=>(

                        <div

                            key={item._id}

                            className="transaction-card"

                        >

                            <div className="transaction-left">

                                <div className="transaction-icon">

                                    <Store size={22}/>

                                </div>

                                <div>

                                    <h3>

                                        {

                                            item.order?.providerSnapshot?.businessName ||

                                            "Restaurant"

                                        }

                                    </h3>

                                    <p>

                                        Order #

                                        {

                                            item.order?.orderNumber ||

                                            item.order?._id

                                        }

                                    </p>

                                </div>

                            </div>

                            <div className="transaction-right">

                                <div className="transaction-amount">

                                    <Wallet size={16}/>

                                    ₹

                                    {

                                        item.deliveryEarning

                                    }

                                </div>

                                <div className="transaction-status">

                                    <CheckCircle2 size={15}/>

                                    {

                                        item.orderStatus

                                    }

                                </div>

                                <div className="transaction-date">

                                    <CalendarDays size={14}/>

                                    {

                                        formatDate(

                                            item.createdAt

                                        )

                                    }

                                </div>

                            </div>

                        </div>

                    ))

                )

            }

        </div>

    );

}

export default TransactionCard;